import { API_BASE } from '../utils/apiBase';
import { passwordLengthError } from '../utils/passwordPolicy';
import { PasswordStrength } from '../components/ui/PasswordStrength';
import { useState } from 'react';
import { Button } from '../components/ui/Button';
import { usePageTitle } from '../hooks/usePageTitle';

export function ResetPasswordPage({ token }) {
  usePageTitle('Reset Password');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    if (password !== confirmPassword) {
      setResult({ ok: false, message: 'Passwords do not match.' });
      return;
    }
    if (passwordLengthError(password)) {
      setResult({ ok: false, message: passwordLengthError(password) });
      return;
    }
    setLoading(true);
    try {
      const apiBase = API_BASE;
      const res = await fetch(`${apiBase}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password, confirmPassword }),
      });
      const data = await res.json();
      setResult({ ok: data.ok, message: data.message });
      if (data.ok) setTimeout(() => { window.location.href = '/'; }, 2000);
    } catch {
      setResult({ ok: false, message: 'Could not connect to server.' });
    }
    setLoading(false);
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>

        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ width: '64px', height: '64px', background: 'linear-gradient(135deg, #f59e0b, #9a3412)', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '32px', margin: '0 auto 16px', boxShadow: '0 8px 24px rgba(245,158,11,0.3)' }}>
            🔑
          </div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '24px', fontWeight: '800', color: 'var(--text)', marginBottom: '6px' }}>
            Set New Password
          </h1>
          <p style={{ color: 'var(--text-3)', fontSize: '14px' }}>Enter and confirm your new password</p>
        </div>

        <div className="card">
          {result?.ok ? (
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ fontSize: '36px', marginBottom: '12px' }}>✅</div>
              <div style={{ fontSize: '15px', fontWeight: '700', color: 'var(--text)', marginBottom: '6px' }}>Password updated!</div>
              <div style={{ fontSize: '13px', color: 'var(--text-3)' }}>Redirecting to login...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="field">
                <label className="label">New Password</label>
                <input
                  className="input"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="At least 15 characters"
                  required
                  autoFocus
                />
              </div>
              <PasswordStrength value={password} />
              <div className="field">
                <label className="label">Confirm Password</label>
                <input
                  className="input"
                  type="password"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  placeholder="Repeat your password"
                  required
                />
              </div>
              {result && !result.ok && (
                <div style={{ background: 'var(--danger-bg)', border: '1px solid var(--danger-border)', color: 'var(--danger)', borderRadius: 'var(--radius-sm)', padding: '10px 14px', fontSize: '13px', fontWeight: '600', marginBottom: '16px' }}>
                  ❌ {result.message}
                </div>
              )}
              <Button type="submit" variant="primary" full loading={loading}>Set Password →</Button>
            </form>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <a href="/" style={{ fontSize: '13px', color: '#f59e0b', fontWeight: '600', textDecoration: 'none' }}>← Back to login</a>
        </div>
      </div>
    </div>
  );
}
